// FuturePath Career experience design tokens (Explore Careers + Career Plan).
// Spec §3, premium dark navy with controlled cyan/blue/purple/green/gold accents.
export const C = {
  bgDeep: '#021735',
  bgAlt: '#03162D',
  surface: '#09254D',
  surface2: '#0D2C55',
  surface3: '#12335D',
  border: '#25568F',
  cyan: '#29E6F4',
  blue: '#339AE5',
  eblue: '#506FEF',
  purple: '#8358F5',
  green: '#2DDBA5',
  gold: '#F2C94C',
  pink: '#F05A87',
  text: '#F4F7FF',
  text2: '#C4D2E3',
  muted: '#C6D4E8',
};

export const GLOW = {
  cyan: '0 0 0 1px rgba(41,230,244,.35), 0 0 18px rgba(41,230,244,.16)',
  hero: '0 0 0 1px rgba(41,230,244,.45), 0 0 24px rgba(41,230,244,.18), 0 12px 36px rgba(0,0,0,.35)',
  purple: '0 0 18px rgba(131,88,245,.20)',
  green: '0 0 16px rgba(45,219,165,.18)',
};

export const GRAD = {
  cta: 'linear-gradient(90deg, #29E6F4 0%, #339AE5 50%, #6D5FF5 100%)',
  hero: 'linear-gradient(135deg, #09254D 0%, #071F43 45%, #071A38 100%)',
  nav: 'linear-gradient(90deg, rgba(41,230,244,.16) 0%, rgba(80,111,239,.20) 55%, rgba(131,88,245,.16) 100%)',
};

// Fit → semantic color + always-present text label (spec: never rely on color alone)
export const FIT = {
  strong: { color: C.green, label: 'Strong Fit' },
  reachable: { color: C.blue, label: 'Reachable' },
  stretch: { color: C.purple, label: 'Stretch' },
};

export function fitBucket(node) {
  // ring 0 = strong, ring 1 = reachable, ring 2 = stretch (distance has meaning)
  if (node.ring === 0 || node.distance === 'Near') return 'strong';
  if (node.ring === 1 || node.distance === 'Moderate') return 'reachable';
  return 'stretch';
}
